import React from 'react';

class NotiPrivacyTransferComp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{
                margin: 0,
                padding: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                background: '#000'
            }}>
                <img 
                    src="https://981park-jeju-asset.s3.ap-northeast-2.amazonaws.com/www/common/web/img/misc/notice-privacy-transfer.jpg" 
                    alt="개인정보 이전 안내" 
                    style={{
                        width: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        objectPosition: 'top'
                    }}
                />
            </div>
        );
    }
}
export default NotiPrivacyTransferComp;